import React from 'react';
import styles from './InputComponents.module.css';

const DateInput = ({ question, value, error, onChange, isSubmitted }) => {
    return (
        <div className={styles.questionWrapper}>
            <label className={styles.questionLabel}>
                {question.text}
                {question.required && <span className={styles.required}>*</span>}
            </label>
            {question.annotation && (
                <span className={styles.annotation}>{question.annotation}</span>
            )}
            <input
                type="date"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={isSubmitted}
                className={`${styles.input} ${error ? styles.inputError : ''}`}
            />
            {error && <span className={styles.errorText}>{error}</span>}
        </div>
    );
};

export default DateInput;